import { LoadingModal } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import ModalFormRenderer from "components/Forms/FormRenderers/ModalFormRenderer";
import { TournamentSessionFormController } from "components/Forms/TournamentSessionForm";
import AppModal from "components/common/AppModal";
import { injectModal } from "lib/injectParams";

const EditTournamentModal: React.FC<{ id: string }> = () => {
  const controller = TournamentSessionFormController.use();
  const { loading } = controller.state;
  const fields = Object.values(controller.fields()).filter(
    (field) => field.group === "basic" || field.group === "schedule",
  );

  if (loading) return <LoadingModal title="Edit tournament" />;

  return (
    <AppModal title="Edit tournament">
      <ModalFormRenderer name="edit-tournament" fields={fields} />
    </AppModal>
  );
};

export default injectModal(TournamentSessionFormController.scope(ApplicationView(EditTournamentModal)));
